import { getCookie } from "../Utils/getCookies";

const safeParse = (data) => {
    try {
        return JSON.parse(data);
    } catch {
        return data || "";
    }
};

export const auditErrorRequest = (error, stepName) => {
    const { config, request } = error;
    const response = error?.response ? error?.response : error;
    const errData = response || request || config;

    const journeyName = getCookie("device-journeyName") || config?.headers?.['JourneyName'] || response?.headers?.['JourneyName'];
    const deviceName = getCookie("device-poid") || config?.headers?.['POID'] || response?.headers?.['POID'];
    const serviceName = config?.serviceName ? config?.serviceName : config?.url ? getServiceName(config?.url) : 'deviceProductDetail';
    const transactionId = response?.headers?.['X-Transaction-Id'] || config?.headers?.['X-Transaction-Id'] || "No Trans Id";
    const correlationId = errData?.headers?.['X-Correlation-Id'] || config?.headers?.['X-Correlation-Id'] || getCookie("device-xCoId");
    const shoppingCartId = getCookie("device-scId");
    const statusCode = errData?.status || request?.status || response?.status;
    const status = statusCode || "NETWORK_ERROR";
    const errorCode = statusCode || response?.message || "Unknown Error"
    const responseMsg = statusCode ? `Customer Connection Rest ${status}` : "Customer Connection Rest";

    clearSessionStorage();
    setSessionStorage(transactionId, stepName, correlationId, journeyName, errorCode, deviceName);

    return {
        "ServiceName": serviceName,
        "JourneyName": journeyName,
        "EndpointURL": request?.responseURL || config?.url || "",
        "ShoppingCartId": shoppingCartId,
        "TransactionId": transactionId,
        "CorrelationId": correlationId,
        "SourceId": "PORTAL_CLIENT",
        "JsonRequest": safeParse(config?.data),
        "JsonResponse": response?.data ? safeParse(response.data) : request?.response ? safeParse(request.response) : responseMsg,
        "BackendRequestType": "MQ",
        "BackendRequest": "",
        "BackendResponse": response?.data ? safeParse(response.data) : "",
        "RequestQueueName": "",
        "ResponseQueueName": "",
        "BackendURL": "",
        "Payload": {
            "header": [
                { Method: config?.method?.toUpperCase(), ...config?.headers, ...request?.headers, ...response?.headers }
            ]
        },
        "HTTPHeaders": {
            "header": [
                { "name": "X-Correlation-Id", "value": correlationId },
                { "name": "X-Source-Channel", "value": config?.headers?.["X-Source-Channel"] || "PORTAL" },
                { "name": "X-Transaction-Id", "value": transactionId }
            ]
        },
        "CreatedOn": config?.headers?.['X-Timestamp'] || new Date().toISOString(),
        "ProcessingTime": 0,
        "Status": status
    };
};

const getServiceName = (url) => {
    const parts = url.split('/');
    let serviceName = parts.pop();
    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

    if (serviceName.includes('?')) serviceName = serviceName.split('?')[0];
    if (uuidRegex.test(serviceName)) serviceName = parts[parts?.length - 2];

    return serviceName;
};

const setSessionStorage = (transactionId, stepName, correlationId, journeyName, errorCode, deviceName) => {
    sessionStorage.setItem("xcoorelationid-error", correlationId);
    sessionStorage.setItem("transactionid-error", transactionId);
    sessionStorage.setItem("journeyname-error", journeyName);
    sessionStorage.setItem("stepname-error", stepName);
    sessionStorage.setItem("errorcode-error", errorCode);
    sessionStorage.setItem("DeviceName", deviceName);
};

const clearSessionStorage = () => {
    sessionStorage.removeItem("xcoorelationid-error");
    sessionStorage.removeItem("transactionid-error");
    sessionStorage.removeItem("journeyname-error");
    sessionStorage.removeItem("stepname-error");
    sessionStorage.removeItem("errorcode-error");
    sessionStorage.removeItem("DeviceName");
}


